<div class="appo-arrival-turn-item">
  <div *ngIf="actions?.includes('IS_MY_TURN')"
       class="appo-arrival-turn-item_speech-bubble mb-3">
    <i class="icosun-say-hello appo-arrival-turn-item_speech-bubble_icon mr-2"></i>
    <span class="bold-condensed">{{'SI_HELLO_READY_TO_SERVE' | translate}}</span>
  </div>
  <div class="appo-arrival-turn-item_info">
    <div class="appo-arrival-turn-item_sequence">{{ticketSequence}}</div>
    <div *ngIf="locationName" class="mt-1">{{'SI_GO_TO' | translate}}&nbsp;{{locationName}}</div>
  </div>
</div>
